const routes = {
    home: '/',
    menu: '/menu',
    gallery: '/gallery',
    contact: '/contact',
    about: '/about',
    appetizers: '/menu/appetizers',
    springrolls: '/menu/springrolls',
    friedrice: '/menu/friedrice',
    pho: '/menu/pho',
    noodlesoup: '/menu/noodlesoup',
    riceplate: '/menu/riceplate',
    ricevermicellibowl: '/menu/ricevermicellibowl',
    familysize: '/menu/familysize',
    stirfriednoodle: '/menu/stirfriednoodle',
    beverage: '/menu/beverage',
};

export default routes;
